import {
  armPhysicalByPartitionAlarmCentral,
  disarmPhysicalByPartitionAlarmCentral,
  sendBypassZones,
  sendPgmActivation,
  sendPgmDeactivation,
  sendSingleBypassZone,
} from '../../index';
import { useMutation } from 'react-query';
import {
  getOutputsOfAlarmCentralId,
  updateOutputsOfAlarmCentralId,
} from '../../../index';

export const useArmPhysicalByPartitionAlarmCentral = () =>
  useMutation(armPhysicalByPartitionAlarmCentral);

export const useDisarmPhysicalByPartitionAlarmCentral = () =>
  useMutation(disarmPhysicalByPartitionAlarmCentral);

export const useSendBypassZones = () => useMutation(sendBypassZones);

export const useSendSingleBypassZone = () => useMutation(sendSingleBypassZone);

export const useSendPgmActivation = () => useMutation(sendPgmActivation);

export const useSendPgmDeactivation = () => useMutation(sendPgmDeactivation);

export const useUpdateOutputsOfAlarmCentralId = () =>
  useMutation(updateOutputsOfAlarmCentralId);

export const useGetOutputsOfAlarmCentralId = () =>
  useMutation(getOutputsOfAlarmCentralId);
